module.exports = __webpack_public_path__ + "img/Yiwen.2ed4b6cb.jpeg";